import React from 'react';
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';
import EditVenueContext from 'contexts/EditVenueContext';
import Venue from 'types/models/Venue';
import Event from 'types/models/Event';
import Article from 'types/models/Article';
import Banner from 'types/models/Banner';
import LuxuryBox from 'types/models/LuxuryBox';
import ListVenuesPage from 'pages/private/admin/ListVenuesPage';
import ListArticlesPage from 'pages/private/admin/ListArticlesPage';
import ListLuxuryBoxesPage from 'pages/private/admin/ListLuxuryBoxesPage';
import CreateVenuePage from 'pages/private/admin/CreateVenuePage';
import CreateLuxuryBoxPage from 'pages/private/admin/CreateLuxuryBoxPage';
import EditVenuePage from 'pages/private/admin/EditVenuePage';
import EditVenuePaymentConfigPage from 'pages/private/admin/EditVenuePaymentConfigPage';
import EditVenueFactoryWidgetsPage from 'pages/private/admin/EditVenueFactoryWidgetsPage';
import EditVenueSNSConfigPage from 'pages/private/admin/EditVenueSNSConfigPage';
import EditVenueDeliveryConfigPage from 'pages/private/admin/EditVenueDeliveryConfigPage';
import EditLuxuryBoxPage from 'pages/private/admin/EditLuxuryBoxPage';
import LuxuryBoxMovementsPage from 'pages/private/admin/LuxuryBoxMovementsPage';
import ListEventsPage from 'pages/private/admin/ListEventsPage';
import CreateEventPage from 'pages/private/admin/CreateEventPage';
import CreateArticlePage from 'pages/private/admin/CreateArticlePage';
import EditEventPage from 'pages/private/admin/EditEventPage';
import EditArticlePage from 'pages/private/admin/EditArticlePage';
import ListBannersPage from 'pages/private/admin/ListBannersPage';
import CreateBannerPage from 'pages/private/admin/CreateBannerPage';
import EditBannerPage from 'pages/private/admin/EditBannerPage';

export default ({ match }: RouteComponentProps): JSX.Element => {
  const [selectedVenue, setSelectedVenue] = React.useState<Venue | null>(null);
  const [selectedEvent, setSelectedEvent] = React.useState<Event | null>(null);
  const [selectedArticle, setSelectedArticle] = React.useState<Article | null>(null);
  const [selectedBanner, setSelectedBanner] = React.useState<Banner | null>(null);
  const [selectedLuxuryBox, setSelectedLuxuryBox] = React.useState<LuxuryBox | null>(null);

  return (
    <EditVenueContext.Provider
      value={{
        selectedVenue,
        setSelectedVenue,
        selectedEvent,
        setSelectedEvent,
        selectedArticle,
        setSelectedArticle,
        selectedBanner,
        setSelectedBanner,
        selectedLuxuryBox,
        setSelectedLuxuryBox,
      }}
    >
      <Switch>
        <Route exact={true} path={`${match.path}`} component={ListVenuesPage} />
        <Route path={`${match.path}/create`} component={CreateVenuePage} />
        <Route path={`${match.path}/:venueId/edit/payment-config`} component={EditVenuePaymentConfigPage} />
        <Route exact={true} path={`${match.path}/:venueId/edit`} component={EditVenuePage} />
        <Route path={`${match.path}/:venueId/edit/sns-config`} component={EditVenueSNSConfigPage} />
        <Route path={`${match.path}/:venueId/edit/factory-widgets`} component={EditVenueFactoryWidgetsPage} />
        <Route path={`${match.path}/:venueId/edit/delivery-config`} component={EditVenueDeliveryConfigPage} />
        <Route exact={true} path={`${match.path}/:venueId/banners`} component={ListBannersPage} />
        <Route path={`${match.path}/:venueId/banners/create`} component={CreateBannerPage} />
        <Route path={`${match.path}/:venueId/banners/edit`} component={EditBannerPage} />
        <Route exact={true} path={`${match.path}/:venueId/events`} component={ListEventsPage} />
        <Route path={`${match.path}/:venueId/events/create`} component={CreateEventPage} />
        <Route path={`${match.path}/:venueId/events/edit`} component={EditEventPage} />
        <Route exact={true} path={`${match.path}/:venueId/articles`} component={ListArticlesPage} />
        <Route path={`${match.path}/:venueId/articles/create`} component={CreateArticlePage} />
        <Route path={`${match.path}/:venueId/articles/edit`} component={EditArticlePage} />
        <Route exact={true} path={`${match.path}/:venueId/luxury-boxes`} component={ListLuxuryBoxesPage} />
        <Route path={`${match.path}/:venueId/luxury-boxes/create`} component={CreateLuxuryBoxPage} />
        <Route path={`${match.path}/:venueId/luxury-boxes/edit`} component={EditLuxuryBoxPage} />
        <Route path={`${match.path}/:venueId/luxury-boxes/:luxuryBoxId/movements`} component={LuxuryBoxMovementsPage} />
        <Redirect to="/private/welcome" />
      </Switch>
    </EditVenueContext.Provider>
  );
};
